import getAllGroups from "../groups/getAllGroups";
import getPeople from "../people/getPeople";
import Data from "../types/Data";

export default function getAllGroupsAndPeople(data: Data) {
  return [...getAllGroups(data), ...getPeople(data)];
}
